import { uri } from '../constants';
export const getAllLabels = async () => {
  try {
    const response = await fetch(`${uri}/users/labels`);
    if (!response.ok) throw new Error('Failed to fetch labels');
    return await response.json();
  } catch (error) {
    console.error('Error fetching labels:', error);
    throw error;
  }
}
export const getLabels = async (userId) => {
  try {
    const response = await fetch(`${uri}/users/${userId}/labels`);
    if (!response.ok) throw new Error('Failed to fetch labels');
    return await response.json();
  } catch (error) {
    console.error('Error fetching labels:', error);
    throw error;
  }
};
export const getLabel = async (userId, labelId) => {
  try {
    const response = await fetch(`${uri}/users/${userId}/labels/${labelId}`);
    if (!response.ok) throw new Error('Failed to fetch label');
    return await response.json();
  } catch (error) {
    console.error('Error fetching label:', error);
    throw error;
  }
}

export const createLabel = async (userId, labelData) => {
  try {
    const response = await fetch(`${uri}/users/${userId}/labels`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(labelData)
    });
    if (!response.ok) throw new Error('Failed to create label');
    return await response.json();
  } catch (error) {
    console.error('Error creating label:', error);
    throw error;
  }
};

export const updateLabel = async (userId, labelId, labelData) => {
  try {
    const response = await fetch(`${uri}/users/${userId}/labels/${labelId}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(labelData)
    });
    if (!response.ok) throw new Error('Failed to update label');
    return await response.json();
  } catch (error) {
    console.error('Error updating label:', error);
    throw error;
  }
};
export const createBulkLabels = async (data) => {
  try {
    const response = await fetch(`${uri}/users/labels/bulk`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    });
    if (!response.ok) throw new Error('Failed to create labels');
    return await response.json();
  } catch (error) {
    console.error('Error creating labels:', error);
    throw error;
  }
}
